export function buildFilterUrl({categoryUrl, filters = {}, meta = {}}) {
    const url = new URL(categoryUrl);
    url.search = '';
    url.hash = '';
    url.pathname = `${url.pathname.replace(/\/+$/, '')}/`;

    const entries = Object.entries(filters)
        .filter(([group, value]) => /^[1-9]\d*$/.test(String(group)) && /^[1-9]\d*$/.test(String(value)))
        .sort(([left], [right]) => Number(left) - Number(right));
    const selected = Object.fromEntries(entries);
    const order = Array.isArray(meta.order) ? meta.order.map(String) : [];
    const hasMetadata = entries.length > 0 && entries.every(([group, value]) => {
        const groupMeta = meta.groups?.[group];
        const valueMeta = meta.values?.[group]?.[value];

        return order.includes(group)
            && typeof groupMeta?.kind === 'string'
            && groupMeta.kind !== ''
            && typeof groupMeta?.prefix === 'string'
            && groupMeta.prefix !== ''
            && valueMeta?.kind === groupMeta.kind
            && valueMeta?.prefix === groupMeta.prefix
            && typeof valueMeta?.slug === 'string'
            && valueMeta.slug !== '';
    });

    if (hasMetadata) {
        for (const group of order) {
            if (!(group in selected)) {
                continue;
            }

            const groupMeta = meta.groups[group];
            const valueMeta = meta.values[group][selected[group]];
            url.pathname += `${groupMeta.prefix}-${valueMeta.slug}/`;
        }

        return url.href;
    }

    if (entries.length > 0) {
        url.searchParams.set('f', entries.map(([group, value]) => `${group}:${value}`).join(';'));
    }

    return url.href;
}
